<template>
    <v-container fluid class="scroll-y fullscreen" pa-0>
        <v-card
            class="mx-auto"
            flat
            :loading="loading"
            loader-height="10"
            tile
        >
            <v-toolbar
            color="#003a6f"
            dark
            flat
            >
                <v-toolbar-title>{{ pageTitle }}</v-toolbar-title>
            </v-toolbar>
        </v-card>
        <v-row
            align="center"
            justify="center"
            class="dashboard-links"
        >
            <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
            >
                <v-card
                    light
                    to="/job_report"
                    outlined
                    color="#1565c0"
                >
                    <v-card-title class="headline d-flex justify-center">                             
                        <v-icon
                            x-large
                            center
                            class="secondary--text"
                        >
                            mdi-briefcase-check-outline
                        </v-icon>
                    </v-card-title>
                    <v-card-text class="text-center">
                        <span class="title text-uppercase font-weight-bold white--text">Job Report</span>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
            >
                <v-card
                    light
                    to="/lead_report"
                    outlined
                    color="#1565c0"
                >
                    <v-card-title class="headline d-flex justify-center">                             
                        <v-icon
                            x-large
                            center
                            class="secondary--text"
                        >
                            mdi-account-check
                        </v-icon>
                    </v-card-title>
                    <v-card-text class="text-center">
                        <span class="title text-uppercase font-weight-bold white--text">Lead Report</span>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        data () {
            return {

            }
        },
        created() {
            this.pageTitle = this.$route.meta.title
        },
        methods: {

        }
    }
</script>

<style lang="sass">
.w-100
    width: 100%

@media only screen and (min-width: 600px)
    .form-row
        &.half 
            max-width: 50%

        &.third
            max-width: 33.33%
</style>